// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j5RH","content":"styles_content__2JvF1"};